import { defineComponent as _defineComponent } from 'vue'
import { type Colors } from '@/composables/useBannersColors';

interface Props {
  data: {
    items: {
      link: string;
      image?: string;
      title?: string;
      subtitle?: number | string;
      variant?: Colors;
      size?: 'small' | 'big';
    }[];
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCardsSection',
  props: {
    data: null
  },
  setup(__props: any) {



const classOfCard = (size = 'big') => {
  return size !== 'small'
    ? 'col-span-4 sm:col-span-4 lg:col-span-2'
    : 'col-span-4 sm:col-span-2 lg:col-span-1';
};

return { __sfc: true,classOfCard }
}

})